import { Box, Grid, Typography } from "@mui/material";
import PageSection from "components/shared/PageSection";
// assets
import RotatingCellVideo from "assets/videos/rotating-cells/c_MCF_2.mp4";

/**
 * * Aiming Our Focus page of the Platform section
 * @returns {React.ReactElement} AimingOurFocusPage
 */
export default function AimingOurFocusPage() {
  return (
    <PageSection
      id="platform-section-AimingOurFocus"
      backgroundSx={{
        backgroundColor: "black",
      }}
    >
      <Grid container spacing={{ xs: 4, md: 10 }}>
        <Grid
          item
          xs={12}
          md={5}
          lg={6}
          order={{ xs: 2, md: 1 }}
          display="flex"
          align="center"
        >
          <Box
            backgroundColor="black"
            borderRadius={1000}
            sx={{
              width: { xs: "90%", sm: "65%", md: "100%" },
              aspectRatio: 1,
              margin: "auto",
            }}
            overflow="hidden"
            display="flex"
            flexDirection="column"
            align="center"
            alignItems="center"
          >
            <Box mb={-8} mt={-2}>
              <video autoPlay loop muted playsInline width="100%" height="100%">
                <source src={RotatingCellVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </Box>
            <Typography variant="caption" zIndex={1000}>
              3D holographic image of
            </Typography>
            <Typography variant="caption" zIndex={1000}>
              cancer cells in blood
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={7} lg={6} order={{ xs: 1, md: 2 }}>
          <SectionText />
        </Grid>
      </Grid>
    </PageSection>
  );
}

/**
 * * Text for the Aiming Our Focus page
 * @param {Object} props
 * @returns {React.ReactElement} SectionText
 */
function SectionText(props) {
  return (
    <>
      <Typography variant="h2" {...props}>
        Aiming our focus
      </Typography>
      <Typography variant="body1" py={2} {...props}>
        This revelation inspired us to think of early detection in more
        comprehensive ways. Not only is it critical to detect these early
        harbingers of cancer, but profiling them will reveal what makes them
        survive and later re-emerge. Coupled with early detection, we believe
        these extraordinary insights will usher in new treatments that can
        fundamentally tip the scales in the fight against cancer.
      </Typography>
    </>
  );
}
